import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fe4626c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "blog-card style1" }
const _hoisted_5 = { class: "blog-info blog-info-info" }
const _hoisted_6 = { class: "blog-metainfo list-style" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))
const _hoisted_10 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "blog-img blog-img-dynamic",
                style: _normalizeStyle({ backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})` })
              }, null, 4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", null, [
                    _hoisted_7,
                    _createTextVNode(),
                    _createVNode(_component_router_link, { to: "#" }, {
                      default: _withCtx(() => [
                        _createTextVNode("La Poste du Bénin SA")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_8,
                    _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}